module.exports = __webpack_public_path__ + "static/img_simba-logo.b5c14dc5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/simba/img_simba-logo.svg
// module id = 1105
// module chunks = 241005775333813